/**
 * Every element brain's `SidePanel` counts as focusable, verbatim (`SidePanel.tsx:13-14`): the W3C APG
 * dialog set, disabled controls excluded.
 */
const FOCUSABLE_SELECTOR =
	'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), details, summary, audio[controls], video[controls], iframe, [contenteditable]:not([contenteditable="false"])';

/**
 * Brain's visibility filter, verbatim (`SidePanel.tsx:45-56`): an `aria-hidden` subtree, a
 * `display: none` ancestor or a zero-size element matches the selector but cannot take focus.
 */
function isFocusable(element: HTMLElement): boolean {
	if (element.hasAttribute('aria-hidden') && element.getAttribute('aria-hidden') !== 'false') {
		return false;
	}
	if (element.offsetParent === null) {
		return false;
	}

	return element.getClientRects().length > 0;
}

/** Ported from Clarity `apps/web/src/shared/ui/SidePanel.tsx` (commit `f9217bb5a`). */
/**
 * Moves focus to the first visible focusable element inside `root`, as brain's `SidePanel` does when
 * it opens (`SidePanel.tsx:232-237`). Does nothing when there is none — focus then stays where it was.
 */
export function focusFirstFocusable(root: HTMLElement): void {
	const first = Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).find(isFocusable);

	first?.focus();
}
